var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionTypeFitbImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 108,
    viewBox: "0 0 125 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 25.7896,
    y: 15.918,
    width: 83.2247,
    height: 64.9945,
    rx: 2.77093,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.2059,
    y: 16.2547,
    width: 82.5512,
    height: 64.321,
    rx: 2.4342,
    stroke: "black",
    strokeWidth: 0.673465,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1975,
    y: 22.6523,
    width: 69.7502,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1975,
    y: 22.6523,
    width: 69.7502,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1975,
    y: 22.6523,
    width: 69.7502,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1975,
    y: 22.6523,
    width: 69.7502,
    height: 2.37785,
    rx: 1.18892,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1975,
    y: 28.7998,
    width: 69.7502,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1975,
    y: 28.7998,
    width: 69.7502,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1975,
    y: 28.7998,
    width: 69.7502,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1975,
    y: 28.7998,
    width: 69.7502,
    height: 2.37785,
    rx: 1.18892,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1975,
    y: 34.9473,
    width: 69.7502,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1975,
    y: 34.9473,
    width: 69.7502,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1975,
    y: 34.9473,
    width: 69.7502,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1975,
    y: 34.9473,
    width: 69.7502,
    height: 2.37785,
    rx: 1.18892,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 32.1975,
    y: 41.0947,
    width: 70.5428,
    height: 17.4376,
    rx: 2.77093,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.5342,
    y: 41.4315,
    width: 69.8694,
    height: 16.7641,
    rx: 2.4342,
    stroke: "black",
    strokeWidth: 0.673465,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3396 45.2977V54.7776H39.5852V45.2977H40.3396Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 32.1975,
    y: 62.3018,
    width: 69.7502,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1975,
    y: 62.3018,
    width: 69.7502,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1975,
    y: 62.3018,
    width: 69.7502,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1975,
    y: 62.3018,
    width: 69.7502,
    height: 2.37785,
    rx: 1.18892,
    fill: "#E3DFE9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1975,
    y: 68.4492,
    width: 69.7502,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1975,
    y: 68.4492,
    width: 69.7502,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1975,
    y: 68.4492,
    width: 69.7502,
    height: 2.37785,
    rx: 1.18892,
    fill: "#D0A8A8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.1975,
    y: 68.4492,
    width: 69.7502,
    height: 2.37785,
    rx: 1.18892,
    fill: "#E3DFE9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.07031 57.0604L76.4477 17.7734L8.07031 57.0604Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.538 33.2878L115.867 30.1855L110.538 33.2878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5674 87.5973L54.8965 84.4951",
    stroke: "#E3DFE9",
    strokeWidth: 16.7314,
    strokeLinecap: "round"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.1 76.6232C113.932 76.71 114.537 77.4558 114.45 78.2874C114.363 79.1191 113.617 79.7239 112.786 79.6371C111.954 79.5502 111.349 78.8045 111.436 77.9728C111.523 77.1411 112.269 76.5363 113.1 76.6232Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.778901
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4598 94.0595C32.8274 94.2023 33.8219 95.4287 33.6791 96.7963C33.5363 98.164 32.3099 99.1585 30.9423 99.0157C29.5746 98.8729 28.5802 97.6465 28.723 96.2789C28.8658 94.9112 30.0921 93.9167 31.4598 94.0595Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.28085
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5911 6.05366C60.9588 6.19645 61.9532 7.42281 61.8104 8.79046C61.6676 10.1581 60.4413 11.1526 59.0736 11.0098C57.706 10.867 56.7115 9.64064 56.8543 8.27299C56.9971 6.90534 58.2235 5.91086 59.5911 6.05366Z",
    stroke: "#8E8E8E",
    strokeWidth: 1.28085
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90608 37.8262C2.53429 37.8262 3.04434 38.3362 3.04434 38.9644C3.04434 39.5926 2.53429 40.1027 1.90608 40.1027C1.27788 40.1027 0.767822 39.5926 0.767822 38.9644C0.767822 38.3362 1.27788 37.8262 1.90608 37.8262Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.936249
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M122.455 30.3252C123.084 30.3252 123.594 30.8352 123.594 31.4635C123.594 32.0917 123.084 32.6017 122.455 32.6017C121.827 32.6017 121.317 32.0917 121.317 31.4635C121.317 30.8352 121.827 30.3252 122.455 30.3252Z",
    stroke: "#8E8E8E",
    strokeWidth: 0.936249
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.298 5.02734L104.598 0.647298",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.831 2.21875L106.211 3.51817",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.52148 79.6113L7.66072 75.1869",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95239 76.8574L9.3768 77.9967",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.492 99.376L102.383 94.895",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M99.772 96.7139L104.253 97.605",
    stroke: "#4D5762",
    strokeWidth: 0.545506
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTypeFitbImg);
export default __webpack_public_path__ + "static/media/question_type_fitb_img.68b09266f3e76ec1839f2e881f8c1bf0.svg";
export { ForwardRef as ReactComponent };